var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orders-listing-page",class:{ 'with-floating-buttons': _vm.showFloatingButtons }},[(_vm.isCallCenter)?_c('call-center-orders-dashboard'):_c('filial-orders-page'),_c('collapsed-orders-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }